import axios from "axios/index";
import qs from "qs";

export default {
  addCamera: ({commit}, payload) => {
    axios({
      url: '/engine/cameras',
      method: 'POST',
      data: qs.stringify(payload)
    })
      .then((response) => {
        commit('cameras/ADD_CAMERA', response.data, {root: true});
      })
      .catch(err => {
        /* eslint-disable */
        console.log(err);
      });
  },
  modifyCamera: ({commit}, payload) => {
    axios({
      url: '/engine/cameras/' + payload.id,
      method: 'PUT',
      data: qs.stringify(payload)
    })
      .then((response) => {
        commit('cameras/REPLACE_CAMERA', response.data, {root: true});
      })
      .catch(err => {
        /* eslint-disable */
        console.log(err);
      });
  },
  removeCamera: ({commit}, id) => {
    axios({
      url: '/engine/cameras/' + id,
      method: 'DELETE'
    })
      .then(() => {
        commit('cameras/REMOVE_CAMERA', id, {root: true});
      })
      .catch(err => {
        /* eslint-disable */
        console.log(err);
      });
  }
};